import { useMemo } from 'react';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetailWithTooltip } from './components/TriggerValueDetailWithTooltip';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const LynxTradeTriggerDetails = ({ trigger, triggerType }: Props) => {
  const poolAddress = useMemo(() => {
    if (trigger.context?.poolAddress) {
      return trigger.context.poolAddress;
    }

    if (trigger.signature) {
      const match = trigger.signature.match(/@([^@]+)$/);
      return match ? match[1] : '';
    }

    return '';
  }, [trigger.context?.poolAddress, trigger.signature]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetailWithTooltip
        label="Pool Address"
        value={maskAddressValue(poolAddress) ?? ''}
        tooltip={poolAddress}
      />
    </div>
  );
};
